import {PatientTherapySequence} from '@cypro/engine/schema'
import {Suspense} from 'react'
import {AdministerDrawer} from './administer-drawer'
import {drawer} from '@cypro/ui/components'
import {PatientTherapySequenceProvider} from '@/shared/contexts/patient-therapy-sequence-context'

export function getAdministerDrawerId(sequence: PatientTherapySequence) {
  return `administed-drawer-${sequence.id}`
}

export function openAdministerDrawer(sequence: PatientTherapySequence) {
  const id = getAdministerDrawerId(sequence)
  drawer.open(id, {
    id,
    children: (
      <Suspense fallback={null}>
        {sequence && (
          <PatientTherapySequenceProvider key={sequence.id} sequenceId={sequence.id}>
            <AdministerDrawer sequence={sequence} />{' '}
          </PatientTherapySequenceProvider>
        )}
      </Suspense>
    ),
    placement: 'bottom',
    blockInverseIndex: true,
    contentProps: {
      maxWidth: '100%',
    },
  })
}
